import './styles.css';

import notFound from 'components/Shared/Error/NotFound';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Invite from '../Invite';
import SignIn from './signin';
import { fetchCourse } from 'actionCreators/course';
import SignUp from './signup';
import { requestLoginAccounts } from 'actionCreators/auth';
import { pushMessage } from 'actionCreators/messages';
import { fetchCourseTemplate } from 'actionCreators/template';
import { ACCOUNTS_TOKEN, IS_PROD, ACCOUNTS_AMBIENT, NUTROR_LOGO } from 'settings';
import { IParams } from 'interface/accounts';
import { getCdnUrl, removeParamUrl } from 'utils';

interface IProps {
  match: any;
  requestLoginAccounts: typeof requestLoginAccounts;
  fetchCourse: typeof fetchCourse;
  fetchCourseTemplate: typeof fetchCourseTemplate;
  pushMessage: typeof pushMessage;
}

interface IPropsFromConnect {
  initialTemplate: any;
  template: any;
  isFree: any;
  isAuthenticated: boolean;
  course: any;
  customization: any;
}

interface IState {}

export class Login extends Component<IProps & IPropsFromConnect, IState> {
  static routes = [
    {
      path: '',
      exact: true,
      authenticWhen: false,
      component: SignIn,
      redirect: '/vitrine',
    },
    {
      path: 'cadastro',
      exact: true,
      authenticWhen: false,
      component: SignUp,
      redirect: '/vitrine',
    },
    {
      path: 'cadastro/:courseHash',
      exact: true,
      authenticWhen: false,
      component: SignUp,
      redirect: (props: any) => {
        return props.match.params.courseHash ? `/curso/${props.match.params.courseHash}` : '/vitrine';
      },
    },
    {
      // Handling invalid invite url
      path: 'convite/:courseHash',
      exact: true,
      allowAnonymous: true,
      component: Invite,
      redirect: (props: any) => {
        return props.match.params.courseHash ? `/curso/${props.match.params.courseHash}` : '/vitrine';
      },
    },
    {
      path: ':courseHash',
      exact: true,
      authenticWhen: false,
      component: SignIn,
      redirect: (props: any) => {
        return props.match.params.courseHash ? `/curso/${props.match.params.courseHash}` : '/vitrine';
      },
    },
    {
      path: '*',
      exact: true,
      allowAnonymous: true,
      component: notFound,
    },
  ];

  componentDidMount() {
    this.loadApplication();
  }

  loadApplication = async () => {
    if (!this.props.isAuthenticated) {
        this.loadTemplate();
      let layout = this.choseLayout();
      (window as any).Eduzz?.Accounts?.login(ACCOUNTS_TOKEN, this.sendParams(layout)).subscribe((token: any) => {
        if (token) {
          this.handleSubmit(token);
        }
        // Removing only accounts_tokens from url query to keep accounts_invitation and any other parameter in the url
        const url = removeParamUrl(['accounts_token'], `${window.location.pathname}${window.location.search}`);
        window.history.pushState(null, null, url);
      });
    }
  };

  choseLayout = () => {
    const { initialTemplate, customization } = this.props;
    if (Object.entries(this.props.customization).length > 0) {
      return customization;
    }

    if (initialTemplate?.login_page?.logo_login || initialTemplate?.login_page?.login_background_image) {
      return initialTemplate.login_page;
    }

    return null;
  };

  sendParams = (template: any) => {
    const createMode = String(window.location).includes('cadastro');
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');

    let params: IParams = {
      logo: NUTROR_LOGO,
      bg: getCdnUrl('/assets/img/background_default.jpg'),
      create: String(createMode),
      register: 'false',
      env: !IS_PROD ? ACCOUNTS_AMBIENT : '',
      email,
    };

    if (!template) {
      return params;
    }

    return {
      ...params,
      logo: template.logo_login ? getCdnUrl(template.logo_login) : NUTROR_LOGO,
      bg: getCdnUrl(
        !!template.login_background_image ? template.login_background_image : '/assets/img/background_default.jpg'
      ),
    };
  };

  loadTemplate = () => {
    try {
      if (!!this.getCourseHash()) {
        this.props.fetchCourseTemplate(this.getCourseHash());
      }
    } catch (err) {
    }
  };

  handleSubmit = (token: string) => {
    try {
      this.props.requestLoginAccounts(token, this.getCourseHash());
    } catch (e) {
      const details = e.response && e.response.data && e.response.data.details;
      this.props.pushMessage(details || 'Erro ao enviar solicitação!', 'error');
      this.setState({ isSending: false });
    }
  };

  getCourseHash = () => {
    const pathname = window.location.pathname;
    if (
      pathname === '/v3' ||
      pathname === '/v3/' ||
      pathname === '/' ||
      pathname.match(/\/(v3\/)?admin/) ||
      pathname.match(/\/(v3\/)?notificacoes/)
    ) {
      return '';
    }
    const courseHash = /\/(v3\/)?(convite\/|curso\/|cadastro\/)?(\w{8,40})/g.exec(pathname);
    return courseHash && courseHash[3];
  };

  render() {
    const { children } = this.props;
    return <div>{children}</div>;
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps,
    initialTemplate: state.template.base,
    template: state.template.course,
    isFree: (state.template.course || {}).isFree || false,
    isAuthenticated: state.auth.isAuthenticated,
    customization: state.customization.customizationData,
  };
};

export default connect(mapStateToProps, {
  requestLoginAccounts,
  pushMessage,
  fetchCourse,
  fetchCourseTemplate,
})(Login);
